import { IFilterItem } from 'components/filter-button/filter-button';

type IGetInitialFilterItem = (
	items: { [key: string]: any; id: number | string; title: string }[],
	query?: string | string[]
) => IFilterItem[];

export const getInitialFilterItem: IGetInitialFilterItem = (items, query) => {
	let selected;

	if (!query) return [];

	if (typeof query === 'string') {
		selected = items.map((theme) => {
			if (theme.id !== query) return;
			return {
				id: Number(theme.id),
				label: theme.title
			};
		});
	}

	if (Array.isArray(query)) {
		selected = items.map((theme) => {
			if (!query.find((item) => item === theme.id)) return;
			return {
				id: Number(theme.id),
				label: theme.title
			};
		});
	}

	if (selected) return selected.filter((item) => item) as IFilterItem[];

	return [];
};
